// extracted by mini-css-extract-plugin
module.exports = {"main":"Search_main__3Q_yK","search":"Search_search__3Ilis","input":"Search_input__3Iuo8"};